import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactJWPlayer from 'react-jw-player'
import {
  ThemeProvider,
  Backdrop,
  Collapse,
  Box,
  Button,
  IconManager,
  coreIconPack,
} from '@deseretbook/react-ui'

IconManager.register(coreIconPack)

const playlistPlayer = ({
  libraryUrl,
  videoUrl,
  videoPoster,
  videoContainerId,
}) => {
  const jwPlayer = window.jwplayer(videoContainerId)
  const [isOpen, setIsOpen] = useState(false)
  const [controlsAreCollapsed, setControlsAreCollapsed] = useState(true)

  const subscriber = (action, _) => {
    if (action !== 'watchVideoOnDemand')
      return
    
    setIsOpen(true)
    jwPlayer.play()
  }

  useEffect(() => {
    if (window.contextObserver) {
      window.contextObserver.subscribe(subscriber)
    }
  })

  const onReady = (event) => {
    //jwPlayer.seek()
  }

  return (
    <ThemeProvider>
      <Backdrop
        isOpen={isOpen}
        onMouseEnter={() => { setControlsAreCollapsed(false) }}
        onMouseLeave={() => { setControlsAreCollapsed(true) }}
      >
        <div style={{position: 'absolute', width: 'inherit', zIndex: '1'}}>
          <Collapse isCollapsed={controlsAreCollapsed} animateOpacity={true}>
            <Box
              paddingTop={1}
              paddingRight={1}
              justifyContent='flex-end'
            >
              <Button
                type='button'
                color='primary'
                icon='close'
                isRounded={true}
                onClick={() => { setIsOpen(false) }}
              />
            </Box>
          </Collapse>
        </div>
        <ReactJWPlayer
          image={videoPoster}
          playerId={videoContainerId}
          playerScript={libraryUrl}
          file={videoUrl}
          onReady={onReady}
        />
      </Backdrop>
    </ThemeProvider>
  )
}

playlistPlayer.propTypes = {
  libraryUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  videoPoster: PropTypes.string,
  videoContainerId: PropTypes.string,
}

export default playlistPlayer
